"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheFutureOfHairHealth() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="140691" id="clinical-partnerships" className="relative w-full min-h-screen flex flex-col lg:flex-row bg-background overflow-hidden dark">
      {}
      <div className="relative w-full lg:w-[60%] h-[60vh] lg:h-screen overflow-hidden bg-muted shrink-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1612048/img/high_fashion_voluminous_hair_portrait.png" alt="Modern dental sleep clinic with advanced oral appliance diagnostic technology" className="absolute inset-0 w-full h-full object-cover object-center" />
        
        {}
        <div className="absolute inset-0 bg-primary/10 mix-blend-multiply pointer-events-none" aria-hidden="true" />
        <div className="absolute -bottom-32 -left-32 w-[30rem] h-[30rem] bg-primary/30 blur-[120px] rounded-full pointer-events-none" aria-hidden="true" />
        <div className="absolute top-1/4 -right-32 w-80 h-80 bg-secondary/20 blur-[100px] rounded-full pointer-events-none" aria-hidden="true" />
        
        {}
        <div className="absolute inset-0 bg-gradient-to-b from-transparent to-background/40 lg:hidden pointer-events-none" aria-hidden="true" />
      </div>

      {}
      <div className="relative w-full lg:w-[40%] flex flex-col justify-center px-8 py-16 md:px-16 lg:px-20 xl:px-24 bg-background z-10 shrink-0">
        <div ref={ref} className={`max-w-md transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <h2 className="font-sans font-bold text-5xl md:text-6xl lg:text-7xl xl:text-[5rem] leading-[1.05] tracking-tighter text-foreground mb-6">
            Collaborative<br />Care.
          </h2>
          
          <p className="text-base md:text-lg text-muted-foreground leading-relaxed mb-10">
            Partnering with physicians to provide seamless co-management of sleep-disordered breathing. Our compliance-driven oral appliance therapy offers a proven alternative for patients seeking restorative rest and long-term health.
          </p>
          
          <div className="flex flex-col items-start gap-4">
            <Button size="lg" className="h-12 px-8 text-base font-semibold tracking-wide bg-secondary text-secondary-foreground hover:bg-secondary/90 shadow-lg shadow-secondary/20" asChild>
              <Link to="/PhysiciansPage">
                Refer a Patient
              </Link>
            </Button>
            
            <Button variant="link" className="px-0 text-secondary hover:text-secondary/80 font-medium h-auto py-2" asChild>
              <Link to="/OralAppliancesPage">
                Clinical Evidence
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}